import { render } from "./PaymentMethodList.vue?vue&type=template&id=1cf343b1&ts=true"
import script from "./PaymentMethodList.vue?vue&type=script&lang=ts"
export * from "./PaymentMethodList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItemSection});
